<div class="row justify-content-center">
    <div class="col-5">
      <tm1-card>
        <form id="deleteGate">
          <fieldset style="margin-bottom: 15px">
            <legend>Delete Gate</legend>
            <tm1-typography type="body-m">Are you sure you want to delete
              <b> {{ gateName }} </b></tm1-typography>
            <br />
            <tm1-button  variant="solid" style="margin-right:2%" routerLink="/tools/gates" >
              Back
            </tm1-button>
            <tm1-button color = "negative" variant="solid" style="width: max-content" (click) = "deleteGate(gateName)" >
                Delete Gate
              </tm1-button>
          </fieldset>
        </form>
      </tm1-card>
    </div>
  </div>